import React, { ReactNode } from 'react';

export type EmptyProps = {
  icon?: ReactNode;
  title?: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
};

export function Empty({ icon, title, body, action }: EmptyProps) {
  return (
    <div style={{ textAlign: 'center', padding: '64px 24px', maxWidth: 360, margin: '0 auto' }}>
      <div
        style={{
          width: 56, height: 56, borderRadius: 16,
          background: 'var(--bg-fill-1)', color: 'var(--fg-tertiary)',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 16,
        }}
      >
        {icon}
      </div>
      <div className="t-title3" style={{ marginBottom: 6 }}>{title}</div>
      {body && (
        <div className="t-subhead" style={{ color: 'var(--fg-secondary)', marginBottom: 16 }}>
          {body}
        </div>
      )}
      {action}
    </div>
  );
}

export default Empty;
